import { AfterViewInit, Component, OnDestroy, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-joga',
  templateUrl: './joga.component.html',
  styleUrls: ['./joga.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class JogaComponent implements AfterViewInit, OnDestroy {
  private init(): void {
    (window as any).lb = undefined;

      (function (i, s, o, g, r, a, m) {
        i['FitsseyWidget'] = r; i[r] = i[r] || function () {
          (i[r].q = i[r].q || []).push(arguments)
        }, i[r].l = 1 * (new Date() as any); a = s.createElement(o),
          m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
      })(window, document,
        'script',
        'https://app.fitssey.com/assets/js/lb.widget.prod.js',
        'lb');
    

    (window as any).lb('init', 'Joga-atrium');
  }

  public ngAfterViewInit(): void {
    this.init();
  }

  public ngOnDestroy(): void {
    (window as any).lb('destroy', 'Joga-atrium');
  }
}
